var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-module-group flex",class:{'flex-grow-auto': !_vm.height},style:({'height': _vm.parsePixel(_vm.height)})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }